
















// vendor
import { defineComponent, PropType } from "@vue/composition-api";
// project
import { ReorderableList } from "@/components.generic/reorderable-list";
// local
import { Checkboxes } from "../../ts/types/ItemSettings";

export default defineComponent({
	components:{
		ReorderableList
	},
	props:{
		data:{
			type:Object as PropType<Checkboxes>,
			required:true
		}
	}
});

